import React, { FC, useMemo, useCallback } from 'react'
import { ToggleButton, ToggleAnchor, ViewToggleContainer, Icon, TabText } from './styles'
import { useTranslation } from '../../../hooks/locale'
import { buildPath } from '../../../routes/build-route'
import { PageSubType } from '../../../constants/booking-page-type'
import { getBasePath } from '../../../utils/miscellaneous-utils'
import AnalyticsService from '../../../services/analytics-service'
import { pageTypeEventCategories } from '../../../services/analytics-service/categories'
import PageSubTypeTransport from '../../../transports/common/booking-types-transport'

interface Props {
    pageSubTypeResponse?: PageSubTypeTransport
    isIndexableTabs?: boolean
}

type ToggleConfig = {
    key: string
    label: string
    route?: string
    icon: string
}

const SliderSection: FC<Props> = ({ pageSubTypeResponse, isIndexableTabs = false }) => {
    const { t } = useTranslation()

    const inquiryIconPath = getBasePath('/assets/images/home/inquiry.png')
    const bookingIconPath = getBasePath('/assets/images/home/booking.png')

    const toggleOptions: ToggleConfig[] = useMemo(
        () => [
            {
                key: PageSubType.HOME,
                label: t('makeInquiry'),
                route: pageSubTypeResponse?.homeURL,
                icon: inquiryIconPath,
            },
            {
                key: PageSubType.BOOKING,
                label: t('bookConfirmedStay'),
                route: pageSubTypeResponse?.directBookingURL,
                icon: bookingIconPath,
            },
        ],
        [t],
    )

    const handleNavigation = useCallback((key: string, route?: string) => {
        AnalyticsService.trackClickEvent(pageTypeEventCategories.HOME, key)
        window.location.href = buildPath(route ?? '/')
    }, [])

    return (
        <ViewToggleContainer>
            {toggleOptions.map(({ key, label, route, icon }) => {
                const isActive = pageSubTypeResponse?.pageSubType === key

                if (isIndexableTabs) {
                    return (
                        <ToggleAnchor
                            key={key}
                            href={buildPath(route ?? '/')}
                            isActive={isActive}
                            onClick={() => AnalyticsService.trackClickEvent(pageTypeEventCategories.HOME, key)}
                        >
                            <Icon src={icon} alt={label} />
                            <TabText>{label}</TabText>
                        </ToggleAnchor>
                    )
                }

                return (
                    <ToggleButton
                        key={key}
                        isActive={isActive}
                        disabled={isActive}
                        onClick={!isActive ? () => handleNavigation(key, route) : undefined}
                    >
                        <Icon src={icon} alt={label} />
                        <TabText>{label}</TabText>
                    </ToggleButton>
                )
            })}
        </ViewToggleContainer>
    )
}

export default SliderSection
